/** Display a readable label without changing the field key sent to the API. */
export function formatFilterLabel(key: string): string {
    const words = key
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .trim()
        .split(/\s+/);
    const acronyms: Record<string, string> = {
        db: 'DB', ecu: 'ECU', id: 'ID', kw: 'KW', ols: 'OLS', ps: 'PS', sha1: 'SHA1', sha256: 'SHA256', tcu: 'TCU'
    };
    return words
        .map(word => acronyms[word.toLowerCase()] ?? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .replace(/^Win OLS\b/, 'WinOLS');
}
